// import HeaderBanner from '@/components/header/HeaderBanner';
import HeaderGroup from '@/components/header/HeaderGroup';
import { useEffect } from 'react';
import { UiCommon } from '@/common/common';

const Header = () => {
	useEffect(() => {
		UiCommon.headerScroll();
		UiCommon.addEvent();
	}, []);

	return (
		<header id="header" className="header has-banner">
			{/* <HeaderBanner /> */}
			<HeaderGroup />
		</header>
	);
};

export default Header;
